import React, { memo } from 'react';

const TextChangeHandler = ({
	data: { 
		startX = 0, 
		startY = 0,
		quantity, 
		changeId, 
		auto = false,
	},
	onChangeHandlerClicked,
	disabled = false,
	active = true,
}) => {
	return (
		<>
			{quantity && (
				<div
					className={ `letter__handler ${auto ? ' letter__handler--auto' : 'letter__handler--manual'} noselect${disabled ? ' disabled' : ''}${active ? ' active' : ''}` }
					style={ {
						left: (startX - 4) + 'px',
						top: (startY - 9) + 'px',
					} }
					onClick={ () => onChangeHandlerClicked(changeId, startX - 2, startY - 7) }
				>
					<p>{quantity} { auto ? ` A` : ` R`}</p>
                        
				</div>
					
			)}
		</>
	);
};
export default memo(TextChangeHandler);